
import { useState, useEffect, useRef } from 'react';
import Hero from './components/Hero';
import ProgramSchedule from './components/ProgramSchedule';
import News from './components/News';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';

export default function HomePage() {
  const [isVisible, setIsVisible] = useState<{ [key: string]: boolean }>({});
  const sectionRefs = useRef<{ [key: string]: HTMLElement | null }>({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible((prev) => ({ ...prev, [entry.target.id]: true }));
          }
        });
      },
      { threshold: 0.1 }
    );

    Object.values(sectionRefs.current).forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0a0a0a] to-[#1a1a1a]">
      <div id="hero" ref={(el) => (sectionRefs.current.hero = el)}>
        <Hero />
      </div>
      
      <div 
        id="schedule" 
        ref={(el) => (sectionRefs.current.schedule = el)}
        className={`transition-all duration-1000 ${isVisible.schedule ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
      >
        <ProgramSchedule />
      </div>
      
      <div 
        id="news" 
        ref={(el) => (sectionRefs.current.news = el)}
        className={`transition-all duration-1000 ${isVisible.news ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
      >
        <News />
      </div>
      
      <div 
        id="contact" 
        ref={(el) => (sectionRefs.current.contact = el)}
        className={`transition-all duration-1000 ${isVisible.contact ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
      >
        <Contact />
      </div>
      
      <Footer />
      <ChatWidget />
    </div>
  );
}
